function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_174",
  "data-name": "Group 174",
  transform: "translate(-495.196 -238.301)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_245",
  "data-name": "Path 245",
  d: "M498.42,265.581a39.346,39.346,0,1,1-2.008,8.925",
  transform: "translate(0 0)",
  fill: "none",
  stroke: "#68d6c7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_173",
  "data-name": "Group 173",
  transform: "translate(515.091 264.172)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_5",
  "data-name": "Line 5",
  y1: 4.391,
  x2: 4.391,
  transform: "translate(36.523)",
  fill: "none",
  stroke: "#68d6c7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_246",
  "data-name": "Path 246",
  d: "M504.514,260.218,518.006,274.9l19.719-21.26",
  transform: "translate(-504.514 -245.938)",
  fill: "none",
  stroke: "#68d6c7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})));

var SvgConfirmedChecked = function SvgConfirmedChecked(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80.705,
    height: 80.705,
    viewBox: "0 0 80.705 80.705",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgConfirmedChecked, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/confirmedChecked.8a921a79.svg";
export { ForwardRef as ReactComponent };